// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"351051b8","186":"5b81383c","344":"8f803e7e","372":"0213d03c","443":"3d34e547","738":"afc29c28","841":"1247f36a","856":"4ec75ec9"}[chunkId] + ".chunk.js";
};